<template>
  <div>
    <!--    弹窗    -->
    <el-dialog title="添加课程关联" :visible.sync="openCardDialog">
      <el-form :model="form" label-width="50%">

        <el-table :data="classItems ? classItems.slice((queryInfo.pagenum-1)*queryInfo.pagesize,queryInfo.pagenum*queryInfo.pagesize) : []" border stripe>
           <el-table-column type="index"></el-table-column>
           <el-table-column label="课程名称" prop="title" width="180px"></el-table-column>
           <el-table-column label="课程介绍" prop="info" width="150px"></el-table-column>
           <el-table-column label="类型" prop="type" width="100px"></el-table-column>
           <el-table-column label="价格（元）" prop="price" width="100px"></el-table-column>
           <el-table-column label="操作" width="160px">
             <template v-slot="scope">
               <input type = checkbox :id="scope.row.id" v-model="checkids" style="zoom: 200%"
                      @change="changeBtn()" :value="scope.row.id">
             </template>
           </el-table-column>
         </el-table>
        <!-- 分页 -->
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryInfo.pagenum"
            :page-sizes="[3, 5, 7, 9]"
            :page-size="queryInfo.pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalSize">
        </el-pagination>
        <el-form-item>
          <el-col :span="6">
            <el-button type="primary" @click="save()">保存</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import {Message} from "element-ui";
import Courses from "../Course/Courses";

export default {
  name: "AddCourseDialog",
  components: {Courses},
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    uid: {},
  },

  computed: {
    openCardDialog: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val) // openCardDialog改变的时候通知父组件
      }
    }
  },
  data() {
    return {
      form: {},
      uid:'',
      checkids: [],
      queryInfo: {
        query: '',
        pagenum: 1, // 当前页数
        pagesize: 5 // 当前每页显示的条数
      },
      totalSize: '',
    }
  },
  watch: {
    uid: function (newVal, oldVal) {
      console.log('newVal'+newVal)
      this.uid = newVal;  //newVal即是uid
      this.getUserInfo();
      this.getAllCourses();
    }
  },
   created() {
      //this.getAllCourses()
     this.getUserInfo();
    },


  methods: {
   // 获取全部课程数据
        async getAllCourses() {
          const {data: res} = await this.$http.get(`/users/${this.uid}/notCourses`)
           console.log('getAllCourses'+this.uid)
          this.classItems = res.data;
          this.totalSize = res.data.length
        },
    async getUserInfo() {
          console.log('this.visible'+this.visible)
      const {data: res} = await this.$http.get(`/users/`)

      this.form = res.data
    },
    changeBtn() {
      console.log(this.checkids)
    },
     save() {
       const http = this.$http;
       const uid = this.uid;
       // debugger;
      this.checkids.forEach(function(item, index) {

        http.post(`/users/${uid}/addCourseId/${item}/`).then((res) => {
          //console.log(res)
          if (res.data.code === 1){
            Message.success(res.data.data)
            setTimeout(()=>{
              location.reload()
            },300)
          }
        })


        })


    },
    // 监听pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize
    },
    // 监听页码值改变的事件
    handleCurrentChange(pageNum) {
      this.queryInfo.pagenum = pageNum
    },
  },

}
</script>

<style scoped>

</style>
